<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 pl-0 fuente-titulo">
				<p>Configuraci&oacute;n de cuenta</p>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-lg-6 fondo-personal py-3">
				<p class="fuente-subtitulo">Informaci&oacute;n personal</p>
				<p
					class="fuente-texto2"
				>Esta informaci&oacute;n fue recabada y validada por el personal de Difarmer y en caso de requerir alguna modificaci&oacute;n requiere de una validaci&oacute;n directamente con personal Difarmer.</p>
				<p>
					<span class="fuente-texto1 mr-2">Cliente:</span>
					<span class="fuente-texto2">{{configuracionCliente.nombre}}</span>
				</p>
				<p>
					<span class="fuente-texto1 mr-2">Encargado de cuenta:</span>
					<span class="fuente-texto2">{{configuracionCliente.nombreEncargadoCompras}}</span>
				</p>
				<p>
					<span class="fuente-texto1 mr-2">Contacto:</span>
					<span class="fuente-texto2">{{configuracionCliente.telefono}}</span>
				</p>
				<p>
					<span class="fuente-texto1 mr-2">Correo:</span>
					<span class="fuente-texto2">{{configuracionCliente.correo}}</span>
				</p>
				<p>
					<span class="fuente-texto1 mr-2">Ciudad:</span>
					<span class="fuente-texto2">{{configuracionCliente.ciudad}}</span>
				</p>
				<p>
					<span class="fuente-texto1 mr-2">Estado:</span>
					<span class="fuente-texto2">{{configuracionCliente.estado}}</span>
				</p>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6 fondo-cambio py-4">
				<p class="fuente-subtitulo">Cambio de contrase&ntilde;a</p>
				<p class="fuente-texto2">Recuerda que no debes compartir tu contrase&ntilde;a.</p>
				<div class="row">
					<div class="col-12 col-lg-8 col-xl-6">
						<router-link
							class="link btn btn-block fuente-boton text-white"
							to="/clientes/configuracion/cambio-password"
						>Cambiar contrase&ntilde;a</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import servicio from "@/services/servicio-configuracion"
	
	export default {
		data() {
			return {
				configuracionCliente:[]
			}
		},
		mounted() {
			this.obtenerDatosConfiguracion()
		},
		methods: {
			obtenerDatosConfiguracion(){
				servicio.obtenerDatosConfiguracion()
					.then( r => {
						this.configuracionCliente = r.data[0]
					})
					.catch(err => {
						console.log('obtenerDatosConfiguracion', err)
					})
			}
		}

	}
</script>

<style scoped>
	.fondo-personal {
		background-color: var(--color-blanco);
	}
	.fondo-cambio {
		background-color: var(--color-blanco);
	}
	.fuente-titulo {
		font-family: "Open Sans";
		font-weight: bold;
		color: var(--bg-menu-blue);
	}
	.fuente-subtitulo {
		font-family: "Open Sans";
		font-weight: bold;
		color: var(--bg-menu-blue);
	}
	.fuente-texto1 {
		font-family: "Open Sans";
		font-weight: bold;
		color: var(--bg-menu-blue);
	}
	.fuente-texto2 {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.fuente-boton {
		background-color: var(--bg-menu-blue) !important;
	}
	.fuente-boton:hover {
		background-color: var(--color-font-blue) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto1 {
			font-size: 16px !important;
		}
		.fuente-texto2 {
			font-size: 16px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto1 {
			font-size: 16px !important;
		}
		.fuente-texto2 {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto1 {
			font-size: 16px !important;
		}
		.fuente-texto2 {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto1 {
			font-size: 16px !important;
		}
		.fuente-texto2 {
			font-size: 16px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-titulo {
			font-size: 18px !important;
		}
		.fuente-subtitulo {
			font-size: 18px !important;
		}
		.fuente-texto1 {
			font-size: 16px !important;
		}
		.fuente-texto2 {
			font-size: 16px !important;
		}
	}
</style>